import { useRef } from "react"
import styled from "styled-components"
import { Box } from "@fastly/consistently"

import { MikanSpan } from "../Mikan"
import Scroller from "../Scroller/Scroller"

const Card = styled(Box)`
  border-radius: 16px;
`

const CardCarousel = ({ content }) => {
  const { section_content } = content
  const cardRef = useRef(null)

  const cards = section_content
    ? section_content.map((card) => {
        return (
          <Card
            display="grid"
            gridTemplateRows="auto 1fr"
            bg="white"
            p="xl"
            ref={cardRef}
            key={card.contentful_id || card.name}
          >
            <Box as="h3" mb="lg" color="var(--magenta)">
              <MikanSpan text={card.name} />
            </Box>
            <Box display="flex" flexDirection="column" justifyContent="space-between" alignSelf="stretch">
              <MikanSpan>{card?.description?.childMarkdownRemark?.html}</MikanSpan>
            </Box>
          </Card>
        )
      })
    : null

  return <Scroller itemList={cards}></Scroller>
}

export default CardCarousel
